import { FinancialData } from '../financial-data';
import { FinancialArea } from '../financial-area';
import { FinancialDataObjectTypeEnum } from '../enums';
import { CurrencyConversion } from '../currency-conversion';

export class FinancialDataModalPayload {
  taxYear: number;
  typesWithData: FinancialData[];
  objectId: number;
  financialArea: FinancialArea;
  section: string;
  objectType: FinancialDataObjectTypeEnum;
  objectCurrencyConversion: CurrencyConversion[];
  primaryHeaderValue: string;
  secondaryHeaderValue?: string;
  entityCountryId?: number;
}
